// MODIFIED
import React from "react";
import OvertimeRequestPage from "../../v2/pages/Transactions/OvertimeRequestPage";

/**
 * Legacy Wrapper for Overtime Module.
 * Redirects to the V2 implementation to maintain App.js compatibility.
 */
function Overtime({ user, userAccess, isHideSideMenu }) {
  return (
    <OvertimeRequestPage
      user={user}
      userAccess={userAccess}
      isHideSideMenu={isHideSideMenu}
    />
  );
}

export default Overtime;